import {
  Box,
  ExpandMoreRoundedIcon,
  Button,
  Flex,
  Rotate,
  FilterListOutlinedIcon,
  Collapse,
  SearchInput,
} from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { useAdminExamLocationRequestListSearchParams } from '../../hooks';
import { AdminExamLocationRequestListFilterForm } from '../admin-exam-location-request-list-filter-form';

export default function AdminExamLocationRequestListFilterSection() {
  const [{ search }, { changeSearch }] = useAdminExamLocationRequestListSearchParams();
  const [isExpand, { toggle }] = useDisclosure(false);

  const handleSearchInputChange = (value: string) => {
    changeSearch(value);
  };

  return (
    <>
      <Flex sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ width: 300 }}>
          <SearchInput
            placeholder='ค้นหาชื่อสถานที่/หน่วยงาน...'
            defaultValue={search ?? ''}
            onChange={handleSearchInputChange}
          />
        </Box>
        <Button
          variant='outlined'
          color='secondary'
          size='large'
          startIcon={<FilterListOutlinedIcon />}
          endIcon={
            <Rotate in={isExpand}>
              <ExpandMoreRoundedIcon />
            </Rotate>
          }
          onClick={toggle}
        >
          Filter
        </Button>
      </Flex>
      <Collapse in={isExpand} unmountOnExit>
        <AdminExamLocationRequestListFilterForm />
      </Collapse>
    </>
  );
}
